import script from "./InstallmentsSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./InstallmentsSelect.vue?vue&type=script&setup=true&lang=js"

import "./InstallmentsSelect.vue?vue&type=style&index=0&id=396b5dba&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-396b5dba"]])

export default __exports__